import request from '@/utils/request';

// 分页查询应用图标
export function getAppIconListPage(data) {
  return request({
    url: '/app/v2/iconListPage',
    method: 'post',
    data: data
  });
}

// 分页查询表盘图标
export function getDialIconListPage(data) {
  return request({
    url: '/dialInfo/iconListPage',
    method: 'post',
    data: data
  });
}

// 获取活动列表
export function getActivityList(data) {
  return request({
    url: '/portal/activity/listPage',
    method: 'post',
    data: data
  });
}

// 查询最近活动
export function getActivityLatest() {
  return request({
    url: '/portal/activity/latest',
    method: 'get',
  });
}


// 查询最近活动
export function getBannerList() {
  return request({
    url: '/portal/banner/list',
    method: 'get',
  });
}
